import { Checkbox } from '@/components/ui/checkbox'
import { Skeleton } from '@/components/ui/skeleton'

export const ReleaseFormSkeleton = () => {
  return (
    <div>
      <div className="flex h-[82px] w-full items-center justify-between p-4">
        <div className="flex h-full items-center gap-3">
          <Checkbox disabled />
          <Skeleton className="h-[50px] w-[50px] rounded-full" />
          <Skeleton className="h-5 w-[200px]" />
        </div>
      </div>
      <div className="ml-[78px] mr-4 border-b" />
    </div>
  )
}
